import React, { HTMLAttributes, PropsWithChildren } from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

export function AnnouncementCategoryDescription({
  children,
  ...htmlSpanAttributes
}: Readonly<PropsWithChildren<HTMLAttributes<HTMLSpanElement>>>) {
  const { t } = useSonTranslation('Announcement');

  return (
    <p className="announcement__category__category-description" {...htmlSpanAttributes}>
      <dfn className="invisible">{t('categoryDefinition')}: </dfn>
      {children}
    </p>
  );
}
